import type { TOC } from '@ember/component/template-only';

interface PslfDashboardCardInfoSignature {
  Args: {
    data?: string;
    icon: unknown;
    text?: string;
  };
  Blocks: {
    info: [];
  };
  Element: HTMLDivElement;
}

const PslfDashboardCardInfoComponent: TOC<PslfDashboardCardInfoSignature> = <template>
  <div class="tio-stack-center w-full" ...attributes>
    <@icon size="16" class="text-ocean-600 text-4xl leading-none" />
    {{#if (has-block "info")}}
      {{yield to="info"}}
    {{else}}
      <p>{{@text}}</p>
      <p class="font-bold">{{@data}}</p>
    {{/if}}
  </div>
</template>;

export default PslfDashboardCardInfoComponent;
